import { Button, ButtonSize, EventNames } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';
import { useEffect } from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { Modal, ModalButtons, ModalHeading, ModalText } from './Modal';

export const onSessionExpired = () => {
    const event = new CustomEvent(EventNames.SessionExpired);
    window.dispatchEvent(event);
};

export interface LoginModalProps {
    readonly loginUrl: string;
}

export const LoginModal = ({ loginUrl }: LoginModalProps) => {
    const [isVisible, setIsVisible] = React.useState(false);

    const showModal = () => {
        setIsVisible(true);
    };

    const redirectToLogin = () => {
        window.location.href = loginUrl;
    };

    useEffect(() => {
        window.addEventListener(EventNames.SessionExpired, showModal);

        return () => {
            window.removeEventListener(EventNames.SessionExpired, showModal);
        };
    });

    return (
        <Modal open={isVisible} onClose={redirectToLogin} priority>
            <ModalHeading>{getTranslation(keys['modal.sessionExpired.title'])}</ModalHeading>
            <ModalText>{getTranslation(keys['modal.sessionExpired.message'])}</ModalText>
            <ModalButtons>
                <Button size={ButtonSize.Medium} onClick={redirectToLogin}>
                    {getTranslation(keys['actionMenu.logIn'])}
                </Button>
            </ModalButtons>
        </Modal>
    );
};
